<template>
  <BaseLayoutGrid>
    <div v-for="db in ss.state.result.list" :key="db.id" class="grid-item">
      <UiDataCard type="database" :owner="true" :data="db" />
    </div>
  </BaseLayoutGrid>
</template>

<script lang="ts" setup>
interface Props {
  ss: SearchStore<Database>
}
const props = withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.grid-item {
  .jps-card {
    height: 100%;
    max-height: 400px;

    @include is-mobile {
      max-height: initial;
    }
  }
}
</style>
